import { Component, forwardRef } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../../utils/pagination";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../../actions/fillCombo_action";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";
import {
  getVendorRegistrationList_action,
  deleteVendorRegistration_action,
  sendVendorUserCred_action,
  insertVendorConfiguration_action,
} from "../../../../actions/admin_module_action/vendor_action/vendorRegistration_action/vendorRegistration_action";
import {
  getVendorConfigurationDetail_action,
  getVendorExhibitorList_action,
  getVendorConfigurationList_action
} from "../../../../actions/vendor_module_action/exhibitor_access_action";
import {
  exhibitionId,
  serviceTypeId,
  disclaimer,
  toastError,
  toastSuccess, hallMasterListActionId,
  stallTypeActionId,
  stallSizeActionId
} from "../../../../utils/constants";
import VendorDrawer from "../../../../common_components/vendor_module_drawer";
import {
  getAPDetails_action,
  insertUpdateAP_action,
  generateRevisedPI_action,
} from "../../../../actions/admin_module_action/exhibitor_list_action/exhibitor_list_action";
import { Switch } from "antd";
const styles = {
  width: "100%",
};

class VendorRegistrationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      vendorRegistrationList: [],
      currentPage: 1,
      currentPage2: 1,
      ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
      exhibitionList: [],
      CompanyName: "",
      PersonName: "",
      ServiceID: "",
      serviceTypeList: [],
      Status: "Select",
      vendorRegistrationUnEnrollList: [],
      isOpenAc: false,
      accessControlList: [],
      accessControlVendorList: [],
      hallList: [],
      checkedAll: false,
      isOpen: false,
      deleteVendorId: '',
      isOpenExhibitorAccess: false,
      stallTypeList: [],
      stallSizeList: [],
      bareStallSizeList: [],
      shellStallSizeList: [],
      selectedStallType: '',
      selectedAreaType: '',
      selectedStallTypes: [],
      selectedAreaTypes: [],
      selectedBareAreaType: '',
      selectedShellAreaType: '',
      selectedExhibitorType: '',
      selectedExhibitorTypes: [],
      hasAccess: null,
      selectedVendorAccountID: null,
      selectedVendorServiceID: null,
      activeServiceTab: 0,
      serviceConfigurations: {},
      vendorServices: [],
      exhibitorAccessList: [],
      exhibitorAccessCurrentPage: 1,
      exhibitorCheckedAll: false
    };
    this.updateItem = this.updateItem.bind(this);
    this.updateItem2 = this.updateItem2.bind(this);
    this.onOpenAccessControlModal = this.onOpenAccessControlModal.bind(this);
    // this.onViewRevisedPIClick = this.onViewRevisedPIClick.bind(this);
    this.insertUpdateAP = this.insertUpdateAP.bind(this);
    this.fetchExhibitorList = this.fetchExhibitorList.bind(this);
  }

  componentDidMount() {
    this.getFillList(exhibitionId, "", "", "", "", "");
    this.getFillList(serviceTypeId, "", "", "", "", "");
    this.getFillList(hallMasterListActionId, "", "", "", "", "");
    this.getFillList(stallTypeActionId, sessionStorage.getItem("sessionExhibitionID"), "", "", "", "");
    this.getFillList(stallSizeActionId, sessionStorage.getItem("sessionExhibitionID"), "", "1", "", "");

    this.getVenddorRegistrationList();
  }

  // get fill List dropdown
  getFillList(
    actionID,
    exhibitionID,
    moduleID,
    keyValue,
    value,
    exhRegistrationID
  ) {
    const { } = this.state;
    // this.setState({ isLoading: true });
    this.props
      .fill_action(
        actionID,
        exhibitionID,
        moduleID,
        keyValue,
        value,
        exhRegistrationID
      )
      .then((data) => {
        if (data.error != 1) {
          // voucher list
          if (actionID === exhibitionId) {
            // console.log("voucher type data", data.data)
            this.setState({
              exhibitionList: data.data,
            });
          }
          if (actionID === serviceTypeId) {
            console.log("voucher type data", data.data);
            this.setState({
              serviceTypeList: data.data,
            });
          }
          if (actionID === hallMasterListActionId) {
            console.log("voucher type data", data.data);
            this.setState({
              hallList: data.data,
            });
          }
          if (actionID === stallTypeActionId) {
            this.setState({
              stallTypeList: data.data,
            });
          }
          if (actionID === stallSizeActionId) {
            this.setState({
              stallSizeList: data.data,
            });
          }
        } else {
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  addVendor() {
    this.props.navigate("/VendorRegistrationAU", { state: { add: true } });
  }

  // Update Current Page
  updateItem(item) {
    const { vendorRegistrationList } = this.state;
    this.setState({ currentPage: item });
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = vendorRegistrationList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(vendorRegistrationList.length / recordsPerPage);
  }

  updateItem2(item) {
    const { vendorRegistrationUnEnrollList } = this.state;
    this.setState({ currentPage2: item });
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = vendorRegistrationUnEnrollList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(
      vendorRegistrationUnEnrollList.length / recordsPerPage
    );
  }

  getVenddorRegistrationList() {
    const { ExhibitionID, CompanyName, PersonName, ServiceID, Status } =
      this.state;
    this.setState({ isLoading: true });
    this.props
      .getVendorRegistrationList_action(
        ExhibitionID,
        CompanyName,
        PersonName,
        ServiceID,
        Status != "Select" && Status != 1 ? 0 : 1
      )
      .then((data) => {
        if (data.error != 1) {
          data.data.map(item => {
            item.isSelect = false
          })
          this.setState({
            isLoading: false,
            vendorRegistrationList: data.data,
            vendorRegistrationUnEnrollList: data.unEnrollData,
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  clearValue() {
    this.setState({
      ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
      CompanyName: "",
      PersonName: "",
      ServiceID: "",
      Status: "Select",
    });

    setTimeout(() => {
      this.getVenddorRegistrationList();
    }, 100);
  }

  deleteVendorRegistration() {
    const { deleteVendorId } = this.state;
    this.setState({ isLoading: true });
    this.props
      .deleteVendorRegistration_action(deleteVendorId)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false, isOpen: false });
          toastSuccess("Service Partner deleted successfully!");
          this.getVenddorRegistrationList();
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  updateVendor(userId, accountId, AccountType) {
    this.props.navigate("/VendorRegistrationAU", {
      state: {
        AccountID: accountId,
        UserId: userId,
        update: true,
        AccountType: AccountType,
      },
    });
  }

  addWorkOrder(accountId, PrimaryEmail, FirstName, LastName, MobileNo) {
    this.props.navigate("/vendorWorkOrderAU", {
      state: {
        add: true,
        vendorId: accountId,
        EmailID: PrimaryEmail,
        PersonName: FirstName + " " + LastName,
        MobileNumber: MobileNo?.split("91-")[1] ?? null,
      },
    });
  }

  resendUserCred(Userid, AccountID) {
    this.setState({ isLoading: true });
    this.props
      .sendVendorUserCred_action(Userid, AccountID)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toastSuccess("UserID & Password Sent");
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleCheckedVendors(e, id) {
    const { exhibitorList, vendorRegistrationList } = this.state;
    const checked = e.target.checked;

    vendorRegistrationList.length > 0 &&
      vendorRegistrationList.map((data) => {
        if (data.EmpanelVendorID == id) {
          if (checked) {
            data.isSelect = true;
          } else {
            data.isSelect = false;
          }
        }
      });
    console.log("aaaaaaaaaaa", vendorRegistrationList);
    this.setState({ vendorRegistrationList: vendorRegistrationList }, () => {
      // setTimeout(() => {
      const allSelected = vendorRegistrationList.every((item) => item.isSelect == true);

      if (allSelected) {
        this.setState({ checkedAll: true });
      } else {
        this.setState({ checkedAll: false });
      }
      // }, 100);
    });
  }


  onOpenAccessControlModal(mode, id) {
    const {
      isLoading, areasList, exhibitorList, hallList, vendorRegistrationList,
      StallpossessionScheduledDate,
      StallpossessionScheduledDateErr,
    } = this.state;
    var tempList = []
    if (mode == 0) {
      tempList.push(id)
    } else {
      vendorRegistrationList.length > 0 && vendorRegistrationList.map(item => {
        if (item.isSelect) {
          tempList.push(item.EmpanelVendorID)
        }
      })
    }
    this.props
      .getAPDetails_action('', tempList.toString())
      .then((data) => {
        if (data.error != 1) {
          var tempAPlist = []
          tempList.map(item => {
            var obj = { EmpanelVendorID: item, hallList: [] }
            vendorRegistrationList.map(item2 => {
              if (item2.EmpanelVendorID == item) {
                obj.CompanyName = item2.CompanyName
                // obj.ExhRegistrationNo = item2.ExhRegistrationNo
              }
            })
            hallList.map(item2 => {
              obj.hallList.push({ HallId: item2.HallId, ExhibitionID: sessionStorage.getItem("sessionExhibitionID"), ExhregistrationID: '', NonEmpanelVendorID: '', EmpanelVendorID: item, IsAccess: false })
            })
            if (data.data[0].length > 0) {
              data.data[0].map(item2 => {
                if (item == item2.EmpanelVendorID) {
                  hallList.map((item3, i) => {
                    if (item2.HallID == item3.HallId) {
                      obj.hallList[i].ExhibitionID = item2.ExhibitionID
                      obj.hallList[i].EmpanelVendorID = item
                      obj.hallList[i].NonEmpanelVendorID = item2.NonEmpanelVendorID
                      obj.hallList[i].ExhregistrationID = item2.ExhRegistrationID
                      obj.hallList[i].IsAccess = item2.AccessStatus == 'Yes' ? true : false
                    }
                  })
                }
              })
            }
            tempAPlist.push(obj)
          })
          // toastSuccess("Generated Successful
          this.setState({ accessControlList: tempAPlist, isOpenAc: true })
          // this.getExhibitorList();
          this.setState({ isLoading: false });
        } else {
          toastError(data.error)
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });

  }

  onAPClick(exhid, hallid) {
    const {
      isLoading, areasList, exhibitorList, hallList,
      StallpossessionScheduledDate,
      StallpossessionScheduledDateErr, accessControlList,
    } = this.state;
    accessControlList.length > 0 && accessControlList.map(item => {
      if (item.EmpanelVendorID == exhid) {
        item.hallList.map(item2 => {
          if (item2.HallId == hallid) {
            if (item2.IsAccess) {
              item2.IsAccess = false
            } else {
              item2.IsAccess = true
            }
          }
        })
      }
    })
    this.setState({ accessControlList: accessControlList })
  }

  insertUpdateAP() {
    const {
      isLoading, areasList, exhibitorList, hallList,
      StallpossessionScheduledDate,
      StallpossessionScheduledDateErr, accessControlList, accessControlVendorList
    } = this.state;
    var finalList = []
    accessControlList.map(item => {
      item.hallList.map(item2 => {
        finalList.push(item2)
      })
    })
    this.setState({ isLoading: true });
    this.props
      .insertUpdateAP_action(finalList)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Access control updated successfully")
          this.setState({ isLoading: false, isOpenAc: false });
        }
      }).catch((err) => {
        console.log(err);
      });
  }

  handleExhibitorCheckbox(e, exhRegId) {
    const { exhibitorAccessList } = this.state;
    const checked = e.target.checked;
    const updatedList = exhibitorAccessList.map(item => {
      if (item.ExhRegistrationID == exhRegId) {
        return { ...item, isSelected: checked };
      }
      return item;
    });
    const allSelected = updatedList.length > 0 && updatedList.every(item => item.isSelected);
    this.setState({ exhibitorAccessList: updatedList, exhibitorCheckedAll: allSelected });
  }

  handleExhibitorSelectAll(e) {
    const { exhibitorAccessList } = this.state;
    const checked = e.target.checked;
    const updatedList = exhibitorAccessList.map(item => ({ ...item, isSelected: checked }));
    this.setState({ exhibitorAccessList: updatedList, exhibitorCheckedAll: checked });
  }

  submitServiceConfigurations() {
    const { serviceConfigurations, selectedVendorAccountID, vendorServices } = this.state;

    if (!vendorServices || vendorServices.length === 0) {
      toastError("No services configured");
      return;
    }

    const vendorMapping = [];
    const vendorCOnfiguration = [];
    const { exhibitorAccessList } = this.state;
    const selectedExhibitors = exhibitorAccessList.filter(item => item.isSelected);

    vendorServices.forEach(service => {
      const config = serviceConfigurations[service.id];
      const hasAccess = config && config.hasAccess === true;

      if (selectedExhibitors.length > 0) {
        selectedExhibitors.forEach(exh => {
          vendorMapping.push({
            VendorID: selectedVendorAccountID,
            ExhRegistrationID: exh.ExhRegistrationID,
            ServiceID: parseInt(service.id),
            ExhibitionID: parseInt(sessionStorage.getItem("sessionExhibitionID"))
          });
        });
      } else {
        vendorMapping.push({
          VendorID: selectedVendorAccountID,
          ExhRegistrationID: null,
          ServiceID: parseInt(service.id),
          ExhibitionID: parseInt(sessionStorage.getItem("sessionExhibitionID"))
        });
      }

      if (hasAccess && config.selectedStallTypes && config.selectedStallTypes.length > 0) {
        const bareAreaItem = this.state.bareStallSizeList.find(item => item.Code === parseInt(config.selectedBareAreaType));
        const shellAreaItem = this.state.shellStallSizeList.find(item => item.Code === parseInt(config.selectedShellAreaType));
        const isBare = config.selectedStallTypes.includes('1') ? 1 : 0;
        const isShell = config.selectedStallTypes.includes('2') ? 1 : 0;
        vendorCOnfiguration.push({
          ExhibitionID: parseInt(sessionStorage.getItem("sessionExhibitionID")),
          VendorID: selectedVendorAccountID,
          ServiceID: parseInt(service.id),
          IsAccess: 1,
          IsBare: isBare,
          IsShell: isShell,
          BareArea: isBare && bareAreaItem ? bareAreaItem.StallArea : null,
          ShellArea: isShell && shellAreaItem ? shellAreaItem.StallArea : null,
          BareAreaID: isBare && config.selectedBareAreaType ? parseInt(config.selectedBareAreaType) : null,
          ShellAreaID: isShell && config.selectedShellAreaType ? parseInt(config.selectedShellAreaType) : null,
          IsNational: config.selectedExhibitorTypes?.includes('1') ? 1 : 0,
          IsInterNational: config.selectedExhibitorTypes?.includes('2') ? 1 : 0
        });
      } else {
        // If access is not granted or no stall types selected, save with IsAccess false
        vendorCOnfiguration.push({
          ExhibitionID: parseInt(sessionStorage.getItem("sessionExhibitionID")),
          VendorID: selectedVendorAccountID,
          ServiceID: parseInt(service.id),
          IsAccess: hasAccess ? 1 : 0,
          IsBare: 0,
          IsShell: 0,
          BareArea: null,
          ShellArea: null,
          BareAreaID: null,
          ShellAreaID: null,
          IsNational: hasAccess && config.selectedExhibitorTypes?.includes('1') ? 1 : 0,
          IsInterNational: hasAccess && config.selectedExhibitorTypes?.includes('2') ? 1 : 0
        });
      }
    });

    const payload = { vendorMapping, vendorCOnfiguration };
    console.log('Payload being sent:', payload);

    this.setState({ isLoading: true });
    this.props
      .insertVendorConfiguration_action(vendorMapping, vendorCOnfiguration)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Service configurations saved successfully");
          this.setState({ isLoading: false, isOpenExhibitorAccess: false });
        } else {
          toastError(data.msg);
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  }

  clearAndCloseModal() {
    this.setState({
      isOpenExhibitorAccess: false,
      hasAccess: null,
      selectedStallTypes: [],
      selectedAreaTypes: [],
      selectedExhibitorTypes: [],
      selectedBareAreaType: '',
      selectedShellAreaType: '',
      stallSizeList: [],
      bareStallSizeList: [],
      shellStallSizeList: [],
      selectedVendorAccountID: null,
      selectedVendorServiceID: null,
      activeServiceTab: 0,
      serviceConfigurations: {},
      vendorServices: [],
      exhibitorAccessList: [],
      exhibitorAccessCurrentPage: 1,
      exhibitorCheckedAll: false
    });
  }

  parseVendorServices(serviceIds, serviceNames) {
    if (!serviceIds || !serviceNames) return [];
    const ids = serviceIds.split(',').map(id => id.trim());
    const names = serviceNames.split(',').map(name => name.trim());
    return ids.map((id, index) => ({ id, name: names[index] || `Service ${id}` }));
  }

  initializeServiceConfigurations(services) {
    const configs = {};
    services.forEach(service => {
      configs[service.id] = {
        isNewConfiguration: true,
        hasAccess: null,
        selectedStallTypes: [],
        selectedBareAreaType: '',
        selectedShellAreaType: '',
        selectedExhibitorTypes: []
      };
    });
    return configs;
  }

  async loadStallSizes(stallType) {
    try {
      const data = await this.props.fill_action(
        stallSizeActionId,
        sessionStorage.getItem("sessionExhibitionID"),
        "",
        stallType,
        "",
        ""
      );
      if (data.error != 1) {
        const newSizes = data.data || [];
        if (String(stallType) === '1') {
          this.setState({ bareStallSizeList: newSizes });
        } else if (String(stallType) === '2') {
          this.setState({ shellStallSizeList: newSizes });
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async onOpenExhibitorAccessModal(data) {
    console.log("onOpenExhibitorAccessModal called with data:", data);
    const services = this.parseVendorServices(data.ServiceIDs, data.abc);
    const configs = this.initializeServiceConfigurations(services);

    this.setState({
      isOpenExhibitorAccess: true,
      selectedVendorAccountID: data.AccountID,
      selectedVendorServiceID: data.ServiceID || 1,
      vendorServices: services,
      serviceConfigurations: configs,
      activeServiceTab: 0,
      isLoading: true,
    });

    try {
      console.log("Calling getVendorConfigurationDetail_action with ExhibitionID:", sessionStorage.getItem("sessionExhibitionID"), "VendorID:", data.AccountID);
      const res = await this.props.getVendorConfigurationDetail_action(
        sessionStorage.getItem("sessionExhibitionID"),
        data.AccountID,
        "", "", "", "", "", "", ""
      );
      console.log("getVendorConfigurationDetail_action response:", res);

      if (res.error != 1 && res.data) {
        const savedData = res.data.vendorConfigurationDetail || [];
        const exhibitorList2 = res.data.vendorConfigurationDetail2 || [];
        const vendorMappingList = res.data.vendorConfigurationDetail3 || [];
        const updatedConfigs = { ...configs };
        const stallTypesToLoad = new Set();

        savedData.forEach(item => {
          const serviceId = item.ServiceID?.toString();
          if (!serviceId || !updatedConfigs[serviceId]) return;

          updatedConfigs[serviceId].isNewConfiguration = false;
          updatedConfigs[serviceId].hasAccess = item.IsAccess === 1 || item.IsAccess === true;

          const selectedStallTypes = [...(updatedConfigs[serviceId].selectedStallTypes || [])];
          if ((item.IsBare === 1 || item.IsBare === true) && !selectedStallTypes.includes('1')) {
            selectedStallTypes.push('1');
            stallTypesToLoad.add('1');
          }
          if ((item.IsShell === 1 || item.IsShell === true) && !selectedStallTypes.includes('2')) {
            selectedStallTypes.push('2');
            stallTypesToLoad.add('2');
          }
          updatedConfigs[serviceId].selectedStallTypes = selectedStallTypes;

          if (item.BareAreaID) {
            updatedConfigs[serviceId].selectedBareAreaType = item.BareAreaID.toString();
          } else if (item.BareArea) {
            updatedConfigs[serviceId].selectedBareAreaType = item.BareArea.toString();
          }
          if (item.ShellAreaID) {
            updatedConfigs[serviceId].selectedShellAreaType = item.ShellAreaID.toString();
          } else if (item.ShellArea) {
            updatedConfigs[serviceId].selectedShellAreaType = item.ShellArea.toString();
          }

          const selectedExhibitorTypes = [...(updatedConfigs[serviceId].selectedExhibitorTypes || [])];
          if ((item.IsNational === 1 || item.IsNational === true) && !selectedExhibitorTypes.includes('1')) {
            selectedExhibitorTypes.push('1');
          }
          if ((item.IsInterNational === 1 || item.IsInternational === 1 || item.IsInterNational === true || item.IsInternational === true) && !selectedExhibitorTypes.includes('2')) {
            selectedExhibitorTypes.push('2');
          }
          updatedConfigs[serviceId].selectedExhibitorTypes = selectedExhibitorTypes;
        });

        // Load stall sizes for the saved stall types
        for (const stallType of stallTypesToLoad) {
          await this.loadStallSizes(stallType);
        }

        // Collect ExhRegistrationIDs from saved vendor mappings to know which were previously checked
        const savedExhRegIds = new Set();
        vendorMappingList.forEach(item => {
          if (item.ExhRegistrationID) {
            savedExhRegIds.add(item.ExhRegistrationID.toString());
          }
        });

        // Use vendorConfiguration if available (from getVendorConfigurationList), otherwise fall back to exhibitorList2
        const exhibitorListSource = res.data.vendorConfiguration || exhibitorList2 || [];

        // Only mark exhibitors as selected if their ExhRegistrationID was previously saved
        const markedExhibitorList = exhibitorListSource.map(item => ({
          ...item,
          isSelected: item.ExhRegistrationID ? savedExhRegIds.has(item.ExhRegistrationID.toString()) : false
        }));
        const allChecked = markedExhibitorList.length > 0 && markedExhibitorList.every(item => item.isSelected);

        this.setState({
          serviceConfigurations: updatedConfigs,
          exhibitorAccessList: markedExhibitorList,
          exhibitorAccessCurrentPage: 1,
          exhibitorCheckedAll: allChecked,
          isLoading: false,
        }, () => {
          // If the active service has access enabled, fetch the exhibitor list
          const activeService = services[this.state.activeServiceTab];
          if (activeService && updatedConfigs[activeService.id]?.hasAccess) {
            this.fetchExhibitorList(activeService.id);
          }
        });
      } else {
        this.setState({ isLoading: false });
      }
    } catch (err) {
      console.log("getVendorConfigurationDetail_action error:", err);
      this.setState({ isLoading: false });
    }
  }

  async fetchExhibitorList(serviceId) {
    console.log('fetchExhibitorList called with serviceId:', serviceId);
    const config = this.state.serviceConfigurations[serviceId];
    if (!config) {
      console.log('No config found for serviceId:', serviceId);
      return;
    }

    // Only fetch if access is granted
    if (!config.hasAccess) {
      console.log('Access not granted, clearing list');
      this.setState({
        exhibitorAccessList: [],
        exhibitorCheckedAll: false
      });
      return;
    }

    const exhibitionId = sessionStorage.getItem("sessionExhibitionID");
    const vendorId = this.state.selectedVendorAccountID;

    const selectedStallTypes = config.selectedStallTypes || [];
    const stallTypeIDStr = selectedStallTypes.join(',');
    const isBare = selectedStallTypes.includes('1') ? 1 : 0;
    const isShell = selectedStallTypes.includes('2') ? 1 : 0;

    // Look up actual StallArea from separate lists based on selected Code
    const bareAreaItem = this.state.bareStallSizeList.find(item => item.Code === parseInt(config.selectedBareAreaType));
    const shellAreaItem = this.state.shellStallSizeList.find(item => item.Code === parseInt(config.selectedShellAreaType));
    const bareArea = isBare && bareAreaItem ? bareAreaItem.StallArea : '';
    const shellArea = isShell && shellAreaItem ? shellAreaItem.StallArea : '';

    // Exhibitor types
    const exhibitorTypes = config.selectedExhibitorTypes || [];
    const isNational = exhibitorTypes.includes('1') ? 1 : 0;
    const isInternational = exhibitorTypes.includes('2') ? 1 : 0;
    this.setState({ isLoading: true });
    try {
      let res;
      res = await this.props.getVendorConfigurationList_action(
        exhibitionId,
        vendorId,
        stallTypeIDStr, // StallTypeID
        isBare,
        isShell,
        bareArea,
        shellArea,
        isNational,
        isInternational
      );

      if (res.error != 1 && res.data) {
        // res.data could be the array itself or contain vendorConfiguration (exhibitor list). 
        // Based on user's data structure, the exhibitor list comes in res.data.vendorConfiguration
        const exhibitorList = Array.isArray(res.data) ? res.data : (res.data.vendorConfiguration || res.data.vendorConfigurationDetail2 || []);

        // Preserve previously selected checkboxes
        const currentList = this.state.exhibitorAccessList || [];
        const currentlySelectedExhIds = new Set(
          currentList.filter(item => item.isSelected).map(item => item.ExhRegistrationID.toString())
        );

        const markedExhibitorList = exhibitorList.map(item => ({
          ...item,
          isSelected: item.ExhRegistrationID ? currentlySelectedExhIds.has(item.ExhRegistrationID.toString()) : false
        }));

        const allChecked = markedExhibitorList.length > 0 && markedExhibitorList.every(item => item.isSelected);

        this.setState({
          exhibitorAccessList: markedExhibitorList,
          exhibitorAccessCurrentPage: 1,
          exhibitorCheckedAll: allChecked,
          isLoading: false
        });
      } else {
        this.setState({ isLoading: false });
      }
    } catch (e) {
      this.setState({ isLoading: false });
    }
  }

  //on Select All Click
  selectAllVendors(e) {
    const { checkedAll, vendorRegistrationList } = this.state;
    // this.setState({ checkedAll: !checkedAll })
    // const checked = e.target.checked
    // exhibitorList.length > 0 && exhibitorList.map((data) => {
    //     if (checked) {
    //         if (data.StatusID != '1' && data.StatusID != '2') {
    //             data.isSelect = true
    //         }
    //     } else {
    //         data.isSelect = false
    //     }
    // })
    // console.log("yyyyyyyyyyyyy", exhibitorList)

    if (checkedAll) {
      vendorRegistrationList.map((data) => {
        data.isSelect = false;
      });
      this.setState({ checkedAll: false, vendorRegistrationList: vendorRegistrationList });
    } else {
      vendorRegistrationList.map((data) => {
        data.isSelect = true;
      });
      this.setState({ checkedAll: true, vendorRegistrationList: vendorRegistrationList });
    }
  }

  render() {
    const {
      isLoading, accessControlList, isOpenAc,
      ExhibitionID, checkedAll,
      CompanyName,
      PersonName,
      ServiceID, hallList,
      currentPage,
      vendorRegistrationList,
      exhibitionList,
      serviceTypeList,
      Status,
      currentPage2,
      vendorRegistrationUnEnrollList,
      isOpen,
      isOpenExhibitorAccess
    } = this.state;

    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = vendorRegistrationList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(vendorRegistrationList.length / recordsPerPage);

    const recordsPerPage2 = 10;
    const indexOfLastRecord2 = currentPage2 * recordsPerPage2;
    const indexOfFirstRecord2 = indexOfLastRecord2 - recordsPerPage2;
    const currentRecords2 = vendorRegistrationUnEnrollList.slice(
      indexOfFirstRecord2,
      indexOfLastRecord2
    );
    const nPages2 = Math.ceil(
      vendorRegistrationUnEnrollList.length / recordsPerPage2
    );
    console.log(vendorRegistrationList, accessControlList)
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
          <ExhibitorHeader />
        ) : (
          <HeaderWithLogo />
        )}
        <div
          className={
            JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1
              ? "with-dr-container"
              : "with-dr-container com-height"
          }
          style={{
            marginTop:
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7
                ? 84
                : "",
          }}
        >
          <div class="row m-0">
            {/* <div class="tab-scroll-fixed">
              <p>Service Partner Registration List</p>
            </div> */}
            <div className="breadcrumb-scroll-fixed">
              <h6 className="mb-0 px-3 py-2 text-white">
                Service Partner Registration List
              </h6>
            </div>
          </div>
          <div class="main-content admin-top-space mx-2">
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 ? (
              <VendorDrawer />
            ) : (
              <AdminDrawer />
            )}
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
              <ExhibitorTopMenu />
            ) : null}
            <div class="row m-0">
              <div className="col-md-3">
                <label>Exhibition</label>
                <select
                  className="form-control"
                  id="roledb"
                  // style={{ textAlign: "left" }}
                  value={ExhibitionID}
                  onChange={(e) =>
                    this.setState({ ExhibitionID: e.target.value })
                  }
                >
                  <option>Select</option>
                  {exhibitionList.length > 0 &&
                    exhibitionList.map((data) => (
                      <option key={data.ExhibitionID} value={data.ExhibitionID}>
                        {data.ExhibitionName}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-xl-3 mb-3">
                <label>Company Name</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue=""
                  required=""
                  value={CompanyName}
                  onChange={(e) =>
                    this.setState({ CompanyName: e.target.value })
                  }
                />
              </div>
              <div className="col-xl-3 mb-3">
                <label>Person Name</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue=""
                  required=""
                  value={PersonName}
                  onChange={(e) =>
                    this.setState({ PersonName: e.target.value })
                  }
                />
              </div>
              <div className="col-md-3">
                <label>Status</label>
                <select
                  className="form-control"
                  id="roledb"
                  value={Status}
                  onChange={(e) =>
                    this.setState({
                      Status: e.target.value,
                    })
                  }
                >
                  <option value="Select">Select</option>
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
              {/* <div className="col-md-3">
                                <label>Service Type</label>
                                <select
                                    className="form-control"
                                    id="roledb"
                                    // style={{ textAlign: "left" }}
                                    value={ServiceID}
                                    onChange={(e) => this.setState({ ServiceID: e.target.value })}
                                >
                                    <option>Select</option>
                                    {serviceTypeList.length > 0 && serviceTypeList.map((data) => (
                                        <option key={data.ServiceID
                                        } value={data.ServiceID
                                        }>{data.Name}</option>
                                    ))}
                                </select>
                            </div> */}
            </div>

            <div className="row m-0">
              <div className="col-md-12 my-3 my-md-0 text-left">
                <div
                  className="mb-1"
                  role="group"
                  aria-label="Basic example"
                  style={{ float: "right" }}
                >
                  <button
                    type="button"
                    className="btn btn-aqua"
                    onClick={(e) => this.getVenddorRegistrationList()}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-gray mx-2"
                    onClick={(e) => this.clearValue()}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-aqua mt-2 mt-md-0"
                    onClick={() => this.addVendor()}
                  >
                    Add Service Partner
                  </button>
                </div>
              </div>
            </div>
            <div className="row m-0 mx-2">
              <div class="table-responsive px-0">
                <h6 class="p-0">
                  Service Partner list for{" "}
                  {sessionStorage.getItem("ExhibitionName")}
                </h6>
                <table class="table border text-nowrap text-md-nowrap table-bordered mb-0">
                  <thead>
                    <tr>
                      {/* text-center */}
                      <th className="text-center" style={{ width: 60 }}>
                        <input
                          type="checkbox"
                          checked={checkedAll}
                          onChange={(e) => this.selectAllVendors(e)}
                        />
                      </th>
                      <th>Company Name</th>
                      <th>Person Name</th>
                      {/* <th>Owner Name</th> */}
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Country</th>
                      <th>Service Type</th>
                      <th>Status</th>
                      <th>Action</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords.length > 0 && currentRecords != null ? (
                      currentRecords.map((data, i) => (
                        <tr>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              // disabled={data.StatusID == '1' || data.StatusID == '2'}
                              value={data.isSelect}
                              checked={data.isSelect}
                              onChange={(e) =>
                                this.handleCheckedVendors(
                                  e,
                                  data.EmpanelVendorID
                                )
                              }
                            />
                          </td>
                          <td>
                            {data.CompanyName != null ? data.CompanyName : "-"}
                          </td>
                          <td>{data.FirstName != null ? data.FirstName : "-"}</td>
                          {/* <td>{data.Name_Of_CEO_MD_President_Owner != null ? data.Name_Of_CEO_MD_President_Owner : '-'}</td> */}
                          <td>
                            {data.PrimaryEmail != null ? data.PrimaryEmail : "-"}
                          </td>
                          <td>
                            {data.MobileNo &&
                              data.MobileNo.split("-")[1]?.trim() !== ""
                              ? data.MobileNo
                              : "-"}
                          </td>
                          <td>{data.Country != null ? data.Country : "-"}</td>
                          <td>{data.abc || "-"}</td>
                          <td>{data.Status}</td>
                          <td className="text-center">
                            <i
                              className="fa fa-pencil grid-icon"
                              aria-hidden="true"
                              title="Update vendor"
                              style={{ marginRight: "12px", cursor: "pointer" }}
                              onClick={() =>
                                this.updateVendor(data.Userid, data.AccountID)
                              }
                            />
                            <i
                              className="fa fa-plus grid-icon"
                              aria-hidden="true"
                              title="Create Scope of work"
                              style={{ marginRight: "12px", cursor: "pointer" }}
                              onClick={() =>
                                this.addWorkOrder(
                                  data.AccountID,
                                  data.PrimaryEmail,
                                  data.FirstName,
                                  data.LastName,
                                  data.MobileNo
                                )
                              }
                            />
                            <i
                              className="fa fa-trash text-danger"
                              aria-hidden="true"
                              title="Delete vendor"
                              onClick={() =>
                                this.setState({ deleteVendorId: data.AccountID, isOpen: true })
                              }
                              style={{ cursor: "pointer" }}
                            />
                          </td>
                          <td className="text-center">
                            <button
                              type="button"
                              className="btn btn-blue-border py-1 ms-2"
                              onClick={(e) =>
                                this.resendUserCred(data.Userid, data.AccountID)
                              }
                            >
                              Send UserID & Password
                            </button>
                            <button
                              type="button"
                              className="btn btn-blue-border py-1 ms-2"
                              onClick={(e) =>
                                this.onOpenAccessControlModal(
                                  0, data.EmpanelVendorID
                                )
                              }
                            >
                              Access Control
                            </button>
                            <button
                              type="button"
                              className="btn btn-blue-border py-1 ms-2"
                              onClick={() => this.onOpenExhibitorAccessModal(data)}
                            >
                              Exhibitor Control Access
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={10} className="text-center">
                          Record not found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row">
              <div className="mt-2 d-flex justify-content-between align-items-center mb-0">
                {vendorRegistrationList.length > 0 ? (
                  <Pagination
                    nPages={nPages}
                    currentPage={currentPage}
                    setCurrentPage={this.updateItem}
                  />
                ) : (
                  <div></div>
                )}
                <div className="tab-rec pe-2">
                  <p>{`${currentPage} of ${nPages} pages`}</p>
                </div>
              </div>
            </div>
            <div className="row m-0 pe-2">
              <div class="table-responsive sticky-table-wrapper m-0 px-0 mx-2">
                <h6 class="p-0">Un-Enrolled vendor list</h6>
                <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                  <thead class="table-light">
                    <tr>
                      {/* text-center */}
                      <th>Company Name</th>
                      <th>Person Name</th>
                      <th>Owner Name</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Country</th>
                      <th>Service Type</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords2.length > 0 && currentRecords2 != null ? (
                      currentRecords2.map((data, i) => (
                        <tr>
                          <td>
                            {data.CompanyName != null ? data.CompanyName : "-"}
                          </td>
                          <td>{data.FirstName != null ? data.FirstName : "-"}</td>
                          <td>
                            {data.Name_Of_CEO_MD_President_Owner != null
                              ? data.Name_Of_CEO_MD_President_Owner
                              : "-"}
                          </td>
                          <td>
                            {data.PrimaryEmail != null ? data.PrimaryEmail : "-"}
                          </td>
                          <td>
                            {data.MobileNo &&
                              data.MobileNo.split("-")[1]?.trim() !== ""
                              ? data.MobileNo
                              : "-"}
                          </td>
                          <td>{data.Country != null ? data.Country : "-"}</td>
                          <td>{data.abc || "-"}</td>
                          <td>{data.Status}</td>
                          <td class="text-center">
                            <button
                              type="btn"
                              class="btn btn-aqua py-1 px-3"
                              onClick={() =>
                                this.updateVendor(
                                  data.Userid,
                                  data.AccountID,
                                  "Enroll"
                                )
                              }
                            >
                              {" "}
                              Enroll{" "}
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={10} className="text-center">
                          Record not found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="mt-2 d-flex justify-content-between align-items-center">
              {vendorRegistrationList.length > 0 ? (
                <Pagination
                  nPages={nPages2}
                  currentPage={currentPage2}
                  setCurrentPage={this.updateItem2}
                />
              ) : (
                <div></div>
              )}
              <div className="tab-rec pe-2">
                <p>{`${currentPage2} of ${nPages2} pages`}</p>
              </div>
            </div>
            <div class="footer-sec ">
              <div class="sdsd">
                <strong>Disclaimer and Ownership:</strong>
                {disclaimer}
              </div>
            </div>

            <div class="footer-first">
              <div class="container-fluid">
                <div class="footer-first">
                  {" "}
                  ITME All Rights Reserved{" "}
                  <i class="fa fa-copyright" aria-hidden="true"></i> 2023{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.isOpenAc} onRequestClose={() => this.setState({ isOpenAc: false })}
        >
          <div class="modal-dialog modal-xl modal-dialog-centered" style={{ fontSize: 'larger' }}>
            <div className="modal-content shadow-lg border-0 rounded-4">
              <div class="modal-header bg-aqua text-white py-2">
                <h5 class="modal-title" style={{ fontSize: "16px" }}>Access Control</h5>
                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ isOpenAc: false })} ></button>
              </div>
              <div class="modal-body">
                <h5 class="text-dark" style={{ fontSize: "16px" }}>Vendor List</h5>
                <div className="table-responsive">
                  <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                    <thead>
                      <tr>
                        <th className="text-center">Sr. no</th>
                        <th className="text-center">Vendor</th>
                        {hallList.length > 0 && hallList.map((item, i) => (
                          // item.IsActive &&
                          <th className="text-center">{item.HallName}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {/* {currentRecords.length > 0 ? (
                                currentRecords.map((data, index) => ( */}
                      {accessControlList.length > 0 && accessControlList.map((item, i) => (
                        <tr key={Math.random()}>
                          <td className="text-center">
                            {i + 1}
                          </td>
                          <td className="text-center">
                            {item.CompanyName}
                          </td>
                          {item.hallList.length > 0 && item.hallList.map((item2, i) => (
                            // item2.IsActive && 
                            <td className="text-center">
                              <Switch
                                onChange={(e) =>
                                  this.onAPClick(item.EmpanelVendorID, item2.HallId
                                  )
                                }
                                checked={
                                  item2.IsAccess
                                }
                                onColor="aqua"
                                offColor="#fff"
                                offHandleColor="#6c757d"
                                uncheckedIcon={false}
                                checkedIcon={false}
                                // disabled={isView}
                                handleDiameter={10} // smaller knob
                                height={14} // smaller height
                                width={28} // smaller width
                                className="me-1 border small-switch"
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* <div >
                          <strong style={{ fontSize: 'x-large' }}>{this.state.exhNo}</strong><br />
                          <strong>{this.state.exhname}</strong><br /><br />
                        </div> */}
                {/* <div>
                          Damage Marked By: <strong>{this.state.damageMarked}</strong><br />
                          Damage Marked Date: <strong>{moment(this.state.DamageDate).format('DD/MM/YYYY')}</strong><br /><br />
                        </div> */}
                {/* <div>
                          Remark: <strong>{this.state.damageRemark}</strong><br />
                        </div> */}
                {/* <div>
                          Images<br />
                          {imgarr.length > 0 && imgarr.map(item => (
                            <img
                              onClick={() => window.open(item, "_blank", "noopener,noreferrer")}
                              src={item}
                              style={{ margin: '2px', cursor: 'pointer' }}
                              alt="Preview"
                              width="200"
                              height="200"
                            />
                          ))}
                        </div> */}
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-aqua" onClick={() => this.insertUpdateAP()}>Submit</button>
                <button type="button" class="btn btn-gray" onClick={() => this.setState({ isOpenAc: false })}>Cancel</button>
              </div>
            </div>
          </div>
        </Modal>

        <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
          <div className="modal-dialog">
            <div className="modal-content confirm-logout">
              <div class="modal-header text-right p-2">
                <h5 class="modal-title modal_title_text">Confirm Delete!</h5>
                <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ isOpen: false })} ></button>
              </div>
              <div class="modal-body">
                Are you sure you want to delete this record? If yes, the associated scope of work will also be deleted.
              </div>
              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button type="button" class="btn btn-del-pop"
                    onClick={(e) => this.deleteVendorRegistration()}
                  >Yes</button>
                  <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                    onClick={() => this.setState({ isOpen: false })}
                  >No</button>
                </div>
              </div>

            </div>
          </div>
        </Modal>

        <Modal isOpen={this.state.isOpenExhibitorAccess} onRequestClose={() => this.setState({ isOpenExhibitorAccess: false })}>
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content shadow-lg border-0 rounded-4">
              <div className="modal-header bg-aqua text-white py-2">
                <h5 className="modal-title" style={{ fontSize: "16px" }}>Service Wise Configuration</h5>
                <button type="button" className="btn-close btn-close-white text-white" onClick={() => this.clearAndCloseModal()}></button>
              </div>
              <div className="modal-body p-0">
                {this.state.vendorServices.length > 0 && (
                  <>
                    <div className="d-flex border-bottom bg-light">
                      {this.state.vendorServices.map((service, index) => (
                        <button
                          key={service.id}
                          className={`btn px-4 py-3 border-0 rounded-0 ${this.state.activeServiceTab === index
                              ? 'btn-aqua text-white border-bottom border-3 border-aqua'
                              : 'btn-light text-dark'
                            }`}
                          onClick={() => this.setState({ activeServiceTab: index })}
                        >
                          {service.name}
                        </button>
                      ))}
                    </div>

                    <div className="p-4 bg-white">
                      {this.state.vendorServices.map((service, index) => (
                        <div key={service.id} className={this.state.activeServiceTab === index ? '' : 'd-none'}>
                          <h6 className="mb-4 text-aqua">Configuration for {service.name}</h6>

                          <div className="mb-4">
                            <label className="form-label fw-bold">Access</label>
                            <div className="d-flex gap-4">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name={`access_${service.id}`}
                                  checked={this.state.serviceConfigurations[service.id]?.hasAccess === true}
                                  onChange={() => {
                                    const configs = { ...this.state.serviceConfigurations };
                                    configs[service.id].hasAccess = true;
                                    this.setState({ serviceConfigurations: configs }, () => {
                                      this.fetchExhibitorList(service.id);
                                    });
                                  }}
                                />
                                <label className="form-check-label">Yes</label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name={`access_${service.id}`}
                                  checked={this.state.serviceConfigurations[service.id]?.hasAccess === false}
                                  onChange={() => {
                                    const configs = { ...this.state.serviceConfigurations };
                                    configs[service.id].hasAccess = false;
                                    this.setState({ serviceConfigurations: configs });
                                  }}
                                />
                                <label className="form-check-label">No</label>
                              </div>
                            </div>
                          </div>

                          {this.state.serviceConfigurations[service.id]?.hasAccess && (
                            <>
                              <div className="mb-4">
                                <label className="form-label fw-bold">Stall Type</label>
                                <div className="d-flex gap-4 flex-wrap">
                                  {this.state.stallTypeList && this.state.stallTypeList.map((item, idx) => (
                                    <div key={idx} className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={item.Code.toString()}
                                        checked={this.state.serviceConfigurations[service.id]?.selectedStallTypes?.includes(item.Code.toString()) || false}
                                        onChange={async (e) => {
                                          const configs = { ...this.state.serviceConfigurations };
                                          const value = e.target.value;
                                          const isChecked = e.target.checked;
                                          let selectedTypes = [...(configs[service.id].selectedStallTypes || [])];
                                          if (isChecked) {
                                            selectedTypes.push(value);
                                            // Load stall sizes for this stall type
                                            await this.loadStallSizes(value);
                                          } else {
                                            selectedTypes = selectedTypes.filter(type => type !== value);
                                          }
                                          configs[service.id].selectedStallTypes = selectedTypes;
                                          this.setState({ serviceConfigurations: configs }, () => {
                                            this.fetchExhibitorList(service.id);
                                          });
                                        }}
                                      />
                                      <label className="form-check-label">{item.Description}</label>
                                    </div>
                                  ))}
                                </div>
                              </div>

                              <div className="row">
                                {this.state.serviceConfigurations[service.id]?.selectedStallTypes?.includes('1') && (
                                  <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Bare Area Type</label>
                                    <select
                                      className="form-control"
                                      value={this.state.serviceConfigurations[service.id]?.selectedBareAreaType || ''}
                                      onChange={(e) => {
                                        const configs = { ...this.state.serviceConfigurations };
                                        configs[service.id].selectedBareAreaType = e.target.value;
                                        if (e.target.value && !configs[service.id].selectedExhibitorTypes?.length) {
                                          configs[service.id].selectedExhibitorTypes = ['1', '2'];
                                        }
                                        this.setState({ serviceConfigurations: configs }, () => {
                                          this.fetchExhibitorList(service.id);
                                        });
                                      }}
                                    >
                                      <option value="">Select Bare Area Type</option>
                                      {this.state.bareStallSizeList && this.state.bareStallSizeList.map((item, idx) => (
                                        <option key={idx} value={item.Code.toString()}>{item.Description}</option>
                                      ))}
                                    </select>
                                  </div>
                                )}

                                {this.state.serviceConfigurations[service.id]?.selectedStallTypes?.includes('2') && (
                                  <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Shell Area Type</label>
                                    <select
                                      className="form-control"
                                      value={this.state.serviceConfigurations[service.id]?.selectedShellAreaType || ''}
                                      onChange={(e) => {
                                        const configs = { ...this.state.serviceConfigurations };
                                        configs[service.id].selectedShellAreaType = e.target.value;
                                        if (e.target.value && !configs[service.id].selectedExhibitorTypes?.length) {
                                          configs[service.id].selectedExhibitorTypes = ['1', '2'];
                                        }
                                        this.setState({ serviceConfigurations: configs }, () => {
                                          this.fetchExhibitorList(service.id);
                                        });
                                      }}
                                    >
                                      <option value="">Select Shell Area Type</option>
                                      {this.state.shellStallSizeList && this.state.shellStallSizeList.map((item, idx) => (
                                        <option key={idx} value={item.Code.toString()}>{item.Description}</option>
                                      ))}
                                    </select>
                                  </div>
                                )}
                              </div>

                              {(this.state.serviceConfigurations[service.id]?.hasAccess || this.state.serviceConfigurations[service.id]?.selectedBareAreaType || this.state.serviceConfigurations[service.id]?.selectedShellAreaType) && (
                                <div className="mb-3">
                                  <label className="form-label fw-bold">Exhibitor Type</label>
                                  <div className="d-flex gap-4">
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="1"
                                        checked={this.state.serviceConfigurations[service.id]?.selectedExhibitorTypes?.includes('1') || false}
                                        onChange={(e) => {
                                          const configs = { ...this.state.serviceConfigurations };
                                          const value = e.target.value;
                                          const isChecked = e.target.checked;
                                          let selectedTypes = [...(configs[service.id].selectedExhibitorTypes || [])];
                                          if (isChecked) {
                                            selectedTypes.push(value);
                                          } else {
                                            selectedTypes = selectedTypes.filter(type => type !== value);
                                          }
                                          configs[service.id].selectedExhibitorTypes = selectedTypes;
                                          this.setState({ serviceConfigurations: configs }, () => {
                                            this.fetchExhibitorList(service.id);
                                          });
                                        }}
                                      />
                                      <label className="form-check-label">Domestic</label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="2"
                                        checked={this.state.serviceConfigurations[service.id]?.selectedExhibitorTypes?.includes('2') || false}
                                        onChange={(e) => {
                                          const configs = { ...this.state.serviceConfigurations };
                                          const value = e.target.value;
                                          const isChecked = e.target.checked;
                                          let selectedTypes = [...(configs[service.id].selectedExhibitorTypes || [])];
                                          if (isChecked) {
                                            selectedTypes.push(value);
                                          } else {
                                            selectedTypes = selectedTypes.filter(type => type !== value);
                                          }
                                          configs[service.id].selectedExhibitorTypes = selectedTypes;
                                          this.setState({ serviceConfigurations: configs }, () => {
                                            this.fetchExhibitorList(service.id);
                                          });
                                        }}
                                      />
                                      <label className="form-check-label">International</label>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  </>
                )}

                {/* Exhibitor List Table */}
                {this.state.exhibitorAccessList.length > 0 && (
                  <div className="px-4 pb-4">
                    <hr className="my-3" />
                    <h6 className="mb-3 text-aqua">Exhibitor List (Records selected here will not be displayed to vendors.)</h6>
                    <div className="table-responsive">
                      <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <thead className="table-light">
                          <tr>
                            <th className="text-center" style={{ width: 50 }}>
                              <input
                                type="checkbox"
                                checked={this.state.exhibitorCheckedAll}
                                onChange={(e) => this.handleExhibitorSelectAll(e)}
                              />
                            </th>
                            <th className="text-center" style={{ width: 50 }}>Sr.</th>
                            <th>Exh. No.</th>
                            <th>Company Name</th>
                            <th>Person Incharge</th>
                            <th>Email</th>
                            <th>Mobile</th>
                            <th>Stall No.</th>
                            <th>Hall</th>
                            <th>Stall Area</th>
                            <th>Stall Type</th>
                            <th>Exhibitor Type</th>
                            <th>Primary Chapters</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(() => {
                            const exhPerPage = 10;
                            const exhCurrentPage = this.state.exhibitorAccessCurrentPage || 1;
                            const exhIndexOfLast = exhCurrentPage * exhPerPage;
                            const exhIndexOfFirst = exhIndexOfLast - exhPerPage;
                            const exhCurrentRecords = this.state.exhibitorAccessList.slice(exhIndexOfFirst, exhIndexOfLast);
                            return exhCurrentRecords.map((item, idx) => (
                              <tr key={idx}>
                                <td className="text-center">
                                  <input
                                    type="checkbox"
                                    checked={item.isSelected || false}
                                    onChange={(e) => this.handleExhibitorCheckbox(e, item.ExhRegistrationID)}
                                  />
                                </td>
                                <td className="text-center">{exhIndexOfFirst + idx + 1}</td>
                                <td>{item.ExhRegistrationNo || '-'}</td>
                                <td>{item.CompanyName || '-'}</td>
                                <td>{item.PersonIncharge ? item.PersonIncharge + ' ' + (item.LastNamePersonIncharge || '') : '-'}</td>
                                <td>{item.PrimaryEmail ? item.PrimaryEmail.replace('mailto:', '') : '-'}</td>
                                <td>{item.MobileNo || '-'}</td>
                                <td>{item.StallNo || '-'}</td>
                                <td>{item.Hall || '-'}</td>
                                <td>{item.StallArea || '-'}</td>
                                <td>{item.StallTypeName || '-'}</td>
                                <td>{item.ExhibitorType || '-'}</td>
                                <td>{item["PRIMARY CHAPTER"] || '-'}</td>
                              </tr>
                            ));
                          })()}
                        </tbody>
                      </table>
                    </div>
                    {/* Exhibitor List Pagination */}
                    {(() => {
                      const exhPerPage = 10;
                      const totalExhPages = Math.ceil(this.state.exhibitorAccessList.length / exhPerPage);
                      const exhCurrentPage = this.state.exhibitorAccessCurrentPage || 1;
                      if (totalExhPages <= 1) return null;
                      return (
                        <div className="d-flex justify-content-between align-items-center mt-2">
                          <Pagination
                            nPages={totalExhPages}
                            currentPage={exhCurrentPage}
                            setCurrentPage={(page) => this.setState({ exhibitorAccessCurrentPage: page })}
                          />
                          <div className="tab-rec pe-2">
                            <p className="mb-0">{`${exhCurrentPage} of ${totalExhPages} pages (${this.state.exhibitorAccessList.length} records)`}</p>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}
              </div>
              <div className="modal-footer border-top bg-light">
                <button type="button" className="btn btn-aqua px-4" onClick={() => this.submitServiceConfigurations()}>Submit</button>
                <button type="button" className="btn btn-gray px-4 ms-2" onClick={() => this.clearAndCloseModal()}>Cancel</button>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    getVendorRegistrationList_action,
    fill_action, getAPDetails_action,
    insertUpdateAP_action,
    deleteVendorRegistration_action,
    sendVendorUserCred_action,
    insertVendorConfiguration_action,
    getVendorConfigurationDetail_action,
    getVendorExhibitorList_action,
    getVendorConfigurationList_action
  })(VendorRegistrationList)
);
